
import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';

import axios from 'axios';

const ModalAdicionarServico = (props) => {

    const [codigo, setCodigo] = useState('');
    const [discriminacao, setDiscriminacao] = useState('');
    const [cnae, setCnae] = useState('');
    const [loading, setLoading] = useState(false);
    const token = localStorage.getItem('token');

    const handleClose = () => {
        setCodigo('');
        setDiscriminacao('');
        setCnae('');
        props.setOpenModalAdicionarServico(false);
    };

    const handleAgree = async () => {
        setLoading(true);

        if (!codigo || !discriminacao) {
            alert('Por favor, preencha todos os campos.');
            setLoading(false);
            return;
        }

        const response = await axios.post(`${process.env.REACT_APP_API_URL}/adicionarServico`, {
            codigo,
            codigoTributacao: codigo,
            discriminacao,
            cnae,
        }, {
            headers: {
                Authorization: token,
                'Content-Type': 'application/json'
            }
        });
        if (response.data.status === 200) {
            setLoading(false);
            props.setOpenModalAdicionarServico(false);
        } else {
            alert('Erro ao adicionar serviço. Tente novamente.');
            setLoading(false);
        }
        // props.setOpenModalAdicionarServico(false);
    }
    return (
        <React.Fragment>
            <Dialog
                open={props.openModalAdicionarServico}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Adicionar novo serviço"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Por favor, preencha os detalhes do novo serviço que deseja adicionar.
                    </DialogContentText>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', gap: '16px', marginTop: '16px' }}>
                        <TextField label="Código" value={codigo} onChange={(e) => setCodigo(e.target.value)} variant="outlined" size='small' sx={{ width: "48%" }} />
                        <TextField label="cnae" value={cnae} onChange={(e) => setCnae(e.target.value)} variant="outlined" size='small' sx={{ width: "48%" }} />
                    </div>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', gap: '16px', marginTop: '16px' }}>
                        <TextField
                            label="Discriminacao"
                            placeholder="Descreva o serviço aqui"
                            rows={4}
                            multiline
                            fullWidth
                            value={discriminacao}
                            onChange={(e) => setDiscriminacao(e.target.value)}
                        />
                    </div>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', gap: '16px', marginTop: '16px' }}>
                    </div>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'space-between', px: 3, pb: 2 }}>
                    <Button onClick={handleClose} loading={loading} autoFocus color='error' size='small'>Cancelar</Button>
                    <Button onClick={handleAgree} loading={loading} variant='contained' color='success' size='small'>Adicionar Serviço</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

export default ModalAdicionarServico;